
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PartnerHeader extends Vue {
  // В переводе заголовок с переносом строки — здесь он в одну строку
  get title() {
    return String(this.$t("partnerHeader.title")).replace(
      /\s*<br\s*\/?>\s*/gi,
      " "
    );
  }
}
